const Style = `
  <style>
    h3 {
      font-family: Spectral-ExtraLightItalic, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif;
      font-size: 37px;
      margin: 0 0 18px 0;
      line-height: 32px;
      font-weight: normal;
      font-style: italic;
    }
    ul {
      list-style: none;
    }
    .accordion-wrapper {
      font-family: GT-America-Standard-Regular, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif;
      padding-top: 6px;
      border-top: 1px solid #E0DBD0;
    }
    .accordion-header {
      font-family: GT-America-Standard-Regular, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif;
      position: relative;
      font-size: 16px;
      cursor: pointer;
      padding: 18px;
      width: 100%;
      text-align: left;
      border: none;
      outline: none;
      transition: 0.4s;
      align-items: center;
      justify-content: space-between;
      background: transparent;
    }
    .accordion-body {
      font-size: 14px;
      padding: 0 18px;
      max-height: 0;
      overflow: hidden;
      transition: max-height 0.2s ease-in-out;
    }
    .accordion-header.active + .accordion-body {
      max-height: 500px;
    }
    .icon {
      position: absolute;
      right: 10px;
    }
    .accordion-minus-icon {
      top: 12px;
      display: none;
    }
    .accordion-header.active .accordion-plus-icon {
      display: none;
    }
    .accordion-header.active .accordion-minus-icon {
      display: block;
    }
    .accordion-header-text {
      display: inline-block;
      width: 90%;
    }
    .product-faq-theme .accordion-wrapper {
      border-top: none;
    }
    .product-faq-theme .accordion-header {
      display: flex;
      gap: 16px;
      justify-content: space-between;
      align-items: center;
      font-size: 24px;
      padding: 20px 0;
      border-bottom: 1px solid #8ae5d3;
      line-height: 40px;
    }
    .product-faq-theme .accordion-header-text {
      width: unset;
    }
    .product-faq-theme .accordion-body {
      font-size: 16px;
      padding: 0;
    }
    .product-faq-theme .icon {
      position: unset;
      right: unset;
      height: 20px;
    }
    @media (max-width: 768px) {
      h3 {
        font-size: 28px;
      }
      .accordion-body {
        font-size: 12px;
      }
      .accordion-header {
        font-size: 14px;
      }
      .product-faq-theme .accordion-header {
        font-size: 18px;
        line-height: 28px;
      }
      .product-faq-theme .accordion-body {
        font-size: 14px;
      }
    }
  </style>
`;

export default Style;
